document.documentElement.classList.add('zl-js');

const initZampelyExperience = () => {
  const revealItems = document.querySelectorAll('.zl-reveal');

  if ('IntersectionObserver' in window) {
    const revealObserver = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      {
        rootMargin: '0px 0px -8% 0px',
        threshold: 0.08,
      }
    );

    revealItems.forEach((item) => revealObserver.observe(item));
  } else {
    revealItems.forEach((item) => item.classList.add('is-visible'));
  }

  const mobileBars = document.querySelectorAll('[data-zampely-mobile-bar]');
  const purchaseSection = document.querySelector('#acquista');
  const hero = document.querySelector('.zl-hero, .zp-main');

  if (mobileBars.length && hero) {
    const updateMobileBar = () => {
      const heroBottom = hero.getBoundingClientRect().bottom;
      const purchaseVisible = purchaseSection
        ? purchaseSection.getBoundingClientRect().top < window.innerHeight * 0.82 &&
          purchaseSection.getBoundingClientRect().bottom > window.innerHeight * 0.18
        : false;

      mobileBars.forEach((bar) => {
        bar.classList.toggle('is-visible', heroBottom < 40 && !purchaseVisible);
      });
    };

    updateMobileBar();
    window.addEventListener('scroll', updateMobileBar, { passive: true });
    window.addEventListener('resize', updateMobileBar);
  }

  document.querySelectorAll('.zl-faq-item').forEach((item) => {
    item.addEventListener('toggle', () => {
      if (!item.open) return;
      item.parentElement?.querySelectorAll('.zl-faq-item[open]').forEach((openItem) => {
        if (openItem !== item) openItem.removeAttribute('open');
      });
    });
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initZampelyExperience, { once: true });
} else {
  initZampelyExperience();
}

document.addEventListener('shopify:section:load', initZampelyExperience);
